import { render, staticRenderFns } from "./OturumLimitiDialog.vue?vue&type=template&id=d68f8a28&scoped=true"
import script from "./OturumLimitiDialog.vue?vue&type=script&lang=ts"
export * from "./OturumLimitiDialog.vue?vue&type=script&lang=ts"
import style0 from "./OturumLimitiDialog.vue?vue&type=style&index=0&id=d68f8a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d68f8a28",
  null
  
)

export default component.exports